module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_ja-0449cbad6a7ad14ac0677eaf7d7932dc.jpg";